import classNames from "classnames";
import { inject, observer } from "mobx-react";
import { type FunctionComponent, type ReactNode } from "react";
import { compose } from "nvent-web/utils/compose";
import AppStore from "nvent-web/stores/App";
import InstructorGuy from "nvent-web/assets/png/instructor_a_1.png";

import style from "./Banner.module.scss";

interface BannerProps {
  children: ReactNode;
}

interface BannerPropsInner extends BannerProps {
  app: AppStore;
}

const BannerInner: FunctionComponent<BannerPropsInner> = ({ children }) => {
  return (
    <div className={style.banner}>
      <div className={classNames(style.bannerText)}>{children}</div>
      <div className={style.constructorGuy}>
        <img src={InstructorGuy} alt="Instructor Guy" />
      </div>
    </div>
  );
};

export const Banner = compose<BannerProps>(
  inject("app"),
  observer
)(BannerInner);
